// settings/workflow/helper/workflowConfigTemplates.js

export const newStepTemplate = () => ({
  workflowConfigurationStepId: null,
  workflowConfigurationId: null, // set by backend or keep null for create
  stepName: "",
  sequence: 0, // will be normalized before save
  roleId: "",
  roleName: null, // UI only
  tatInHours: 24,
  isActive: true,
  description: null,

  useForRejectionStep: false,
  saveAttachmentsInDms: false,

  // Keep only what your save expects (exclude: isOptional, requireCommentOnApprove, return fields, reject notify)
  requireCommentOnReject: true,

  onRejectAction: null,          // "gotostep" or null
  onRejectGoToSequence: null,    // number
  onRejectMessage: null,

  childSteps: [],

  createdDate: null,
  createdBy: null,
  updateDate: null,
  updatedBy: null,
});

export const newChildStepTemplate = (parentStepId) => ({
  workflowChildStepId: null,
  parentStepId: parentStepId,
  parentStepName: null, // UI only

  childStepName: "",
  sequence: 0, // normalized before save

  roleId: "",
  roleName: null, // UI only

  tatInHours: null,
  isActive: true,
  description: null,

  // fields shown in your DTO
  requireCommentOnReject: true,
  requireAttachmentOnApprove: false,
  requireAttachmentOnReject: false,

  minimumApprovalCount: null,
  allowParallelExecution: false,

  // some payloads include these - keep if your API accepts them (safe to retain)
  onRejectAction: null,
  onRejectNotifyRoleId: null,
  onRejectNotifyRoleName: null,
  onRejectMessage: null,

  createdBy: null,
  createdDate: null,
  updatedBy: null,
  updateDate: null,
  // nestedChildSteps: []
});
